import { ONE_DAY, ONE_HOUR, ONE_MINUTE } from '@/const'
import { useInfoAPIStore, useUserAPIStore } from '@/stores'
import { RemainTime } from '@/types'
/**
 * timestamp의 데이터 포멧을 String으로 변경시키는 함수. default) 2023년 09월 13일 오후 3:38
 */
export const formattedDate = (
  timestamp: string,
  dateOptions?: Intl.DateTimeFormatOptions,
  necessaryTime?: string,
  locale?: string,
): string => {
  const infoAPIStore = useInfoAPIStore()
  const userAPIStore = useUserAPIStore()
  const remainTime = Number(necessaryTime) || 0
  const date = new Date(timestamp)
  date.setMinutes(date.getMinutes() + remainTime)
  const options = dateOptions || {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }
  let currentLocale = navigator.language
  if (infoAPIStore.localeList?.length !== 0) {
    const locale = infoAPIStore.localeList?.find(
      (locale) => locale.id === userAPIStore.userInfo?.localeId,
    )
    if (locale !== undefined) currentLocale = locale.localeGroup
  }
  const formatted = date.toLocaleDateString(locale || currentLocale, options)
  return formatted
}

/**
 * timestamp의 데이터 포멧을 String으로 변경시키는 함수 e.g) 오후 3:38
 */
export const formattedDateTime = (timestamp: string): string => {
  const date = new Date(Number(timestamp))
  const formatted = date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  })
  return formatted
}

export const isSameDay = (timestamp1: string, timestamp2: string): boolean => {
  const date1 = new Date(Number(timestamp1))
  const date2 = new Date(Number(timestamp2))
  // 24 시간 이상인지 체크
  const diffTime = Math.abs(date1.getTime() - date2.getTime())
  const diffDays = Math.ceil(diffTime / ONE_DAY)
  if (diffDays > 1) {
    return false
  }
  // 날짜가 같은지 체크
  const localeDateString1 = date1.toLocaleDateString()
  const localeDateString2 = date2.toLocaleDateString()
  const day1 = new Date(localeDateString1).getDate()
  const day2 = new Date(localeDateString2).getDate()
  return day1 === day2
}
/**
 * timestamp에 necessaryTime(분)를 더한 값을 Date.now()로 빼서 밀리초 차이를 구하는 함수
 * 현재 keyInfo의 timestamp의 형식이 다르다 보니, timezone을 직접 계산해 주어야 함
 * 따라서 ISO string으로 제대로 오는 응답은 offTimezone을 true로 설정해야 함 ㅜ 백엔드와 조율하여 수정 필요
 */
export const formattedDiffTime = (
  timestamp: string,
  necessaryTime: string,
  offTimezone?: boolean,
): number => {
  const userTimeZoneOffsetTime = !offTimezone
    ? new Date().getTimezoneOffset() * ONE_MINUTE
    : 0
  const timeDifference =
    Date.now() - new Date(timestamp).getTime() + userTimeZoneOffsetTime

  const remainTimeMilliseconds =
    Number(necessaryTime) * ONE_MINUTE - timeDifference

  return remainTimeMilliseconds
}

/**
 * formattedDiffTime으로 나온 밀리초 차이를 시간으로 바꿔주는 함수
 */
export const formattedDiff = (
  timestamp: string,
  necessaryTime: string,
): RemainTime => {
  const remainTimeMilliseconds = formattedDiffTime(timestamp, necessaryTime)

  const hours = Math.floor(remainTimeMilliseconds / ONE_HOUR)
  const minutes = Math.ceil((remainTimeMilliseconds % ONE_HOUR) / ONE_MINUTE)

  return {
    hours,
    minutes,
  }
}

/**
 * address를 4자리씩 끊어주는 함수
 */
export const formatEthereumAddress = (address: string) => {
  const chunks = address.match(/.{1,4}/g)
  return chunks?.join(' ')
}

export const formatTimeToDay = (milliseconds: number): number => {
  return Math.floor(milliseconds / ONE_DAY)
}
